<template>
  <div class="Menopause">
    <app-header></app-header>
    <div class="page-wrapper">
      <div class="MenoCard"></div>

      <div
				class="modal fade"
				id="myModal"
				tabindex="-1"
				role="dialog"
				aria-labelledby="myModalLabel"
				aria-hidden="true"
			>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="myModalLabel">Diet Started</h5>
						</div>
						<div class="modal-body">You started the Menopause diet. You can switch back to the standard diet on your profile page.</div>
						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-success"
								data-dismiss="modal"
							>Okay</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Meno Modal -->
			<div class="modal fade" id="menopauseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Meno Calculator</h5>
					</div>
					<div class="modal-body">
						Menopause diet calculator is only available for females.
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-nutri-green" data-dismiss="modal">Okay</button>
					</div>
					</div>
				</div>
			</div>
			<!-- Menu Modal End -->

			<div
				class="modal fade"
				id="exampleModal"
				tabindex="-1"
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Upgrade to VIP</h5>
						</div>
						<div class="modal-body">To start a diet you need to upgrade to VIP first. Would you like to check out our benefits?</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
								type="button"
								class="btn btn-success"
								data-dismiss="modal"
								@click="$router.push('/profile/upgrade')"
							>Okay</button>
						</div>
					</div>
				</div>
			</div>

      <div
        style="padding-bottom:30px;margin-left: 0px;margin-right: 0px;"
        class="panel panel-default card-view"
      >
        <div class="panel-heading">
          <div class="text-center">
            <h5 class="panel-title txt-light">Menopause Diet</h5>
          </div>
          <div class="clearfix"></div>
        </div>
        <div id="collapse_1" class="panel-wrapper collapse in">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-md-offset-3">
                <p
                  style="padding-top: 30px;"
                >The Menopause Calculator will help you find the exact amount of carbs, fat, and protein you need to reach your goal weight. Menopause, and the hormonal changes associated with it, often causes weight gain around the midsection, according to the Academy of Nutrition and Dietetics.</p>
                <br>
                <p>Menopausal weight gain can have serious implications for your health. Excess weight increases the risk of heart disease, type 2 diabetes etc. Healthy eating means reducing your intake of sugar and alcohol and increasing your intake of high fibre foods. Your diet should include more of Omega-3/ Omega-6 fats (the good fats) , Calcium & vitamin D rich foods.</p>
              </div>
            </div>
          </div>
          <div style="margin-top:20px;" class="container">
            <div class="row">
              <div class="col-md-12 text-center buttonFromMenopause">
		      	<a v-if="$store.getters.user.meta_data.gender != 'female'" 
		      	class="btn btn-nutri-green buttonKeto"
                  	data-target="#menopauseModal"
                  	data-toggle="modal">
                 		<span class="btn-text">Start Menopause calculator</span>
                	</a>
                <!-- <a v-show="$store.getters.user.meta_data.gender == 'female'"
                  v-if="$store.getters.user.vip_user"
                  class="btn btn-nutri-green buttonKeto"
                  data-target="#exampleModal"
                  data-toggle="modal"
                >
                  <span class="btn-text">Start Menopause calculator</span>
                </a> -->
                <a v-show="$store.getters.user.meta_data.gender == 'female'"
                  v-if="$store.getters.user.vip_user"
                  class="btn btn-nutri-green buttonKeto"
                  @click="recommendedIntakeCalculation"
                >
                  <span class="btn-text">Start Menopause calculator</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import API from "../../services/api.js";
import AppFooter from "../../components/common/AppFooter.vue";
import AppHeader from "../../components/common/AppHeader.vue";

const api = new API();

	export default {
		data() {
			return {
			}
		},
		components: {
			AppHeader,
			AppFooter,
		},
		methods:{
		recommendedIntakeCalculation() {
			let profile = {
				"recommended_intake_calculation":"menopause"
			} 
			api.updateProfile(profile).then(async response => {
				if (response.data.success) {
						api.me();	
				}
			});
			$('#myModal').modal('show');
    	},
			
		},
		mounted: function () {
	
		}
	}
</script>

<style>
.MenoCard{
	margin-top: -10px;
	background-image: url("https://images.pexels.com/photos/1640770/pexels-photo-1640770.jpeg");
	background-size: cover;
	height: 50vh;
}

.buttonKeto {
  width: 50%;
  margin-top: 4%;
}

.buttonFromMenopause {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Diet/Menopause.vue